import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgEmailTemplate = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 48,
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M23.4617 7.75537C26.0989 7.75538 28.1244 10.6659 28.8074 12.1211L29.732 14.22C29.3162 14.6357 27.5244 16.0012 26.3127 16.7852C24.798 17.7653 23.7995 20.0151 22.8188 20.7997C22.1714 21.3176 20.8349 22.1424 19.3846 23.8327C18.9785 24.3061 17.7263 25.0521 16.9924 26.7987C16.523 27.9159 16.512 28.2876 16.6902 29.5349C16.8327 30.5328 15.9678 29.624 15.6411 30.0695C14.8392 30.4556 13.5198 32.0465 14.7315 33.0444C15.5166 33.6909 15.6201 33.1746 17.8445 33.0444C19.9118 32.9234 20.5345 33.6758 20.8349 33.5041C21.4586 33.1477 21.7687 30.7823 21.8578 30.0695C21.9291 29.4993 23.5027 27.159 24.3343 27.2184C24.5125 27.3966 25.2435 28.9647 26.3127 29.5349C27.6491 30.2477 28.7814 30.4259 30.6524 29.5349C32.5234 28.6439 33.6867 24.7237 35.0232 23.8327C36.3596 22.9417 37.4498 25.0801 38.8753 27.2184C40.3009 29.3567 39.5881 32.5642 37.4498 37.2864C35.3114 42.0085 31.5462 42.5944 20.1417 42.3271C8.73733 42.0598 6.08772 34.0789 4.12758 29.0894C2.16745 24.1 6.88959 17.1504 9.82979 13.7648C12.77 10.3791 20.165 7.75537 23.4617 7.75537Z",
			fill: "#FFD000"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M28.2177 10.6199C26.7583 8.20443 24.2332 6.32855 16.2272 9.22714C6.21982 12.8504 4.03183 21.9462 4.44765 26.266C4.86348 30.5858 7.26222 37.3315 16.957 40.2692C26.6517 43.2069 36.555 39.4858 39.2653 31.8477C41.9757 24.2096 38.2103 23.3719 36.9594 23.274C35.7084 23.1761 34.1044 24.1141 33.8597 25.9813C33.6151 27.8484 30.9928 31.8739 27.1416 29.3735",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.5426 20.349C29.9159 10.8867 40.9332 6.25844 42.2847 5.98309C43.6363 5.70775 43.6363 6.72335 43.6363 7.19646C43.6363 7.66957 42.3297 11.6447 39.4498 15.471C36.5699 19.2972 29.875 23.6607 26.1229 26.0263L26.085 26.0758C24.936 27.5776 23.2922 29.7263 22.8583 28.703C22.4196 27.6685 20.5155 25.624 19.5049 24.7408C19.7307 23.3846 21.9622 22.2414 22.1234 22.1468C22.2524 22.0711 23.1233 20.9167 23.5426 20.349Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.8708 20.8198L27.355 24.6524",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.9808 25.4106C17.7341 25.6685 15.2776 26.4772 15.2439 28.3339C15.2018 30.6549 16.5124 30.7922 12.4689 33.4365C14.0913 34.05 19.688 36.4795 20.6886 33.4365C21.6891 30.3935 21.1749 29.098 22.7519 28.3339",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.8584 17.4557C16.8698 17.5552 15.8385 16.3831 15.7402 15.4073C15.642 14.4315 16.4855 13.8928 17.4741 13.7933C18.4627 13.6937 19.4078 14.4838 19.506 15.4596C19.6327 16.7176 19.0606 17.3346 17.8584 17.4557Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.501 24.6222C12.931 25.5515 11.6789 25.8202 10.7043 25.2224C9.7297 24.6246 9.26272 23.3214 9.83265 22.3922C10.4026 21.4629 11.5851 20.8516 12.5597 21.4494C13.816 22.2199 14.1941 23.4922 13.501 24.6222Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M27.3559 33.4972C28.3541 33.7252 29.0042 34.6066 28.8079 35.4657C28.6117 36.3248 27.6326 36.9546 26.6344 36.7265C25.6362 36.4984 24.9473 35.5292 25.1436 34.6701C25.3966 33.5626 26.1419 33.2198 27.3559 33.4972Z",
			stroke: "#1B1B20",
			strokeWidth: 2.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgEmailTemplate;
